export default __webpack_public_path__ + "static/media/shop.59ef4063.png";